export const YES = 'y';
export const CAPS_Y = "Y"
export const CAPS_N = "N"
export const PDF_FILE_TYPE = "application/pdf";
export const PDF_DATA_URI = "data:application/pdf;base64,";

export const GENERATE_OTP_ATTEMPTS_ALLOWED = 8;

export const SELFIE_MSG_CODE = ["200", "400"]

export const IDLE_USER_TIMEOUT = 1000 * 60 * 30;
export const MAX_WAITING_TIME = 50;

export const TELEBINDING_SOURCE_CHANNEL = "TeleB";
export const PHONE_BANKING_SOURCE_CHANNEL = "PhoneBanking";

export const TELEBINDING_WAITING_STAGES = ["BackflowProcessingStage","CallBackProcessing"];

export const TELEBINDING_STAGES = {
    PII: "Pii",
    POSV: "Posv",
    PAYMENT: "Payment",
    BACKFLOW_PROCESSING: "BackflowProcessingStage",
    CALLBACK_PROCESSING: "CallBackProcessing",
    PAYMENT_PROCESSING: "PaymentProcessing"
}

export const PAYMENT_TYPE = {
   RENEWAL: "RENEWAL",
   INITIAL: "INITIAL"
}

export const PAYMENT_STATUS ={
  SUCCESS: "TXN_SUCCESS",
  FAILED: "TXN_FAILED",
  PENDING: "PENDING"
}

export const API_CONSTANTS = {
  REDIRECT_URL: "tbPaymentCallback",
};

export const ACCOUNT_TYPE_OPTIONS = [
  "Savings Account",
  "Current Account",
  "Cash Credit",
  "NRE",
  "NRO",
  "FCNR"
];
export const DECLRATION_IDS = {
    DISCLAIMER_TEXT: "dec002ax",
    DISCLAIMER_TEXT_FOR_GEN_OTP: "dec005nx",
    ULIP_DISCLAIMER_TEXT: "dec004ul",
    IS_NPS_DISCLAIMER_TEXT: "dec003np",
    PHYSICAL_JOURNEY_TEXT: "dec001pj",
    PAN_ADDHAR_DECLARATION: "dec006ad",
    CLUBBED_OTP_DISCLAIMER: "dec013ClubbedOtp",
    TALIC_BI_DISCLAIMER: "dec007tb",
    CIS_IS_NPS_DISCLAIMER_TEXT: "deccis010np",
    CIS_JOURNEY_TEXT: "deccis008pj",
    CIS_DISCLAIMER_TEXT: "deccis009ax",
    CIS_DISCLAIMER_TEXT_FOR_GEN_OTP: "deccis011nx",
    REGULAR_OTP_DISCLAIMER: "dec014ru",
    IS_PAN_AADHAR_LINKED: "dec016pan",
    BASBA_CONSENT: "decbasba018ax",
    UPFRONT_PAYMENT_CONSENT: "decuppay019ax",
    TMB_CHANNEL_CONSENT: "dec020tmb",
    TMB_CHANNEL_CONSENT: "dec020tmb",
    TELEBINDING_HEALTH: "dec01Teleb"
};

export const ROUTES = {
    OTP_VERIFICATION: "/otp-verification",
    PERSONAL_DETAILS: "/personal-details",
    PAYMENT: "/payment",
    WAITING: "/checking-status",
    TECHNICAL_ERROR: "/technical-error",
    NOT_DECLARATION: "/not-declaration"
}